__webpack_require__.p = "/energy/water/paper/Tumkur_Landscape/";